import React from 'react';
import { Link } from 'react-router-dom';

import MarketingShell from '../marketing/MarketingShell';
import theme from '../marketing/theme.module.css';
import styles from './NotFoundPage.module.css';

/**
 * What a URL that matches nothing should show.
 *
 * There was no catch-all route, so a stale link, a typed address or a path
 * from an older build rendered an empty white page: no message, no heading,
 * no way on except the browser's back button.
 *
 * Where it offers to send you depends on whether anyone is signed in, and so
 * does the chrome around it. A visitor gets the public shell, because a bad
 * URL is often the first page someone ever sees of a site and it should still
 * look like the site and offer the way in. A signed-in customer gets the
 * message on its own: a bar inviting them to Log in or Register, when they
 * are already signed in, is noise at the exact moment they are lost.
 */
export const NotFoundPage: React.FC = () => {
  let signedIn = false;
  try {
    signedIn = Boolean(window.localStorage.getItem('policyora_token'));
  } catch {
    signedIn = false;
  }
  const to = signedIn ? '/dashboard' : '/';
  const label = signedIn ? 'Go to your dashboard' : 'Go to the home page';

  const body = (
    <section className={`${theme.band} ${styles.band}`}>
      <div className={`${theme.wrap} ${styles.inner}`}>
        <p className={theme.eyebrow}>
          <span className={theme.eyebrowDash} aria-hidden="true" />
          Error 404
        </p>
        <h1 className={theme.h1}>We could not find that page</h1>
        <p className={theme.lead}>
          The address <code className={styles.path}>{window.location.pathname}</code> does not
          match anything in PolicyOra. It may be an old link, or the page may have moved.
        </p>
        <Link to={to} className={theme.btnPrimary}>{label}</Link>
      </div>
    </section>
  );

  // Signed in: the message without a bar telling them to sign in.
  if (signedIn) return <div className={theme.theme}>{body}</div>;
  return <MarketingShell>{body}</MarketingShell>;
};

export default NotFoundPage;
